import {EntityModel} from "@fedeltapointofsale/data-client";
import {EventTriggerData} from "./event-trigger.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class EventTriggerEntityModel extends EntityModel<EventTriggerData> {
    constructor(injector: Injector) {
        super(injector, EventTriggerData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
